import React from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import { Env } from '@morningtrain/helpers'
import moment from 'moment'
import { Select } from '@morningtrain/react-fields'
import { useWillConstrain } from '@morningtrain/react-filters'
import { TableHeader } from 'ui/table'
import { Translation } from '@morningtrain/react-translations'

function MonthFilterSyncedWithModel () {
  const defaultYear = Env.get('resources.api.shifts.special_days.month.filters.month.value.year') || moment().year()
  const defaultMonth = Env.get('resources.api.shifts.special_days.month.filters.month.value.month') || moment().month()

  const [month, setMonth] = React.useState({ month: defaultMonth, year: defaultYear })

  useWillConstrain('month', month)

  const currentYear = moment().year()
  const startYear = moment().subtract(5, 'years').year()
  const endYear = moment().add(10, 'years').year()

  const options = []

  for (let year = startYear; year < endYear; year++) {
    options.push({
      value: year, label: year
    })
  }

  const handleChangeYear = (year) => {
    setMonth({
      ...month,
      year: parseInt(year)
    })
  }

  const handleChangeMonth = (changeMonth) => {
    setMonth({
      ...month,
      month: parseInt(changeMonth)
    })
  }

  return (
    <>
      <Select
        options={options}
        name='year'
        defaultValue={currentYear}
        onChange={handleChangeYear}
        className='input-white'
        label={<Translation name='generic.year' />}
      />
      <Select
        enum='month'
        name='month'
        onChange={handleChangeMonth}
        className='input-white'
        defaultValue={month.month}
        label={<Translation name='generic.month' />}
      />
    </>
  )
}

export default MonthFilterSyncedWithModel
